import React from "react";
import "./Relocation_of_buildings.css";
import { Link } from "react-router-dom";
import ContactSection2 from "./ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function Relocation_of_buildings() {
  return (
    <div className="Relocation_of_buildings-page">

      {/* =====================================================
          HERO
      ===================================================== */}

      <div className="Relocation_of_buildings-hero">
        <div className="Relocation_of_buildings-overlay">
          <h1>העברת מבנים</h1>
        </div>
      </div>


      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              TOP TITLE
          ===================================================== */}

          <h2 className="top-text">
            העברת מבנים דורשת תכנון מקצועי, ציוד מתאים וניסיון
            בביצוע עבודות הרמה והובלה. נצר הובלות ומנופים מספקת
            פתרונות להעברת מבנים בהתאם לתנאי השטח ולדרישות הפרויקט.
          </h2>


          {/* =====================================================
              VIDEO
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              העברת מבנים עם נצר הובלות ומנופים
            </div>

            <div className="building-video-wrapper">

              <video
                className="building-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                playsInline
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src="/video/1.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.
              </video>

            </div>

            <p className="building-video-caption">
              צפו בסרטון והכירו את עבודות ההרמה והעברת המבנים
            </p>

          </div>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">
              <img
                src="/images/23.jpeg"
                alt="העברת מבנים"
              />
            </div>

            <div className="text-box">

              <p>
                העברת מבנה ממקום למקום היא עבודה מורכבת הדורשת
                תכנון מוקדם והתאמה מדויקת של אמצעי ההרמה וההובלה.
                לפני תחילת העבודה יש לבחון את גודל המבנה, המשקל,
                נקודות ההרמה, תנאי הגישה והדרך שבה המבנה יועבר
                למיקום החדש.
              </p>

              <p>
                כאשר מדובר במבנים ניידים, יחידות מגורים, משרדים,
                מבנים תעשייתיים או מבנים מיוחדים, חשוב לבצע את
                העבודה בצורה מסודרת ולתכנן מראש את שלבי ההרמה,
                ההעמסה, ההובלה וההצבה.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            העברת מבנים – תכנון נכון לפני תחילת העבודה
          </h2>

          <div className="bottom-text">

            <p>
              כל עבודת העברת מבנה מתחילה בבדיקת תנאי השטח.
              יש לבחון את נקודת המוצא ואת נקודת היעד, את אפשרויות
              הגישה למשאית ולמנוף ואת תנאי הדרך לאורך מסלול ההובלה.
            </p>

            <p>
              תכנון מוקדם מאפשר לבחור את אמצעי ההובלה וההרמה
              המתאימים למשימה ולצמצם הפתעות במהלך העבודה.
              במקרים מסוימים יש צורך בהתייחסות מיוחדת לרחובות
              צרים, שערים, מכשולים, קווי תשתית או מגבלות גובה.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              הרמת המבנה והעמסתו להובלה
            </h2>

            <p>
              לאחר בדיקת התנאים בשטח ניתן לתכנן את אופן הרמת
              המבנה. יש להתאים את ציוד ההרמה למבנה ולמשקל שלו
              ולבחון את נקודות האחיזה המתאימות.
            </p>

            <p>
              לאחר ההרמה ניתן להעביר את המבנה אל אמצעי ההובלה
              המתאים ולהמשיך לשלב ההובלה אל היעד. כל שלב דורש
              תיאום וביצוע מסודר כדי להגיע לתוצאה מדויקת.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              הובלת מבנים למרחקים שונים
            </h2>

            <p>
              העברת מבנים יכולה להתבצע בתוך אותו אתר, בין חלקים
              שונים של יישוב או בין אזורים שונים בארץ. בהתאם
              למרחק ולתנאי הדרך, מתכננים את אופן ההובלה ואת
              הציוד הדרוש לביצוע המשימה.
            </p>

            <p>
              נצר הובלות ומנופים מספקת שירותי הובלה והרמה
              בפריסה רחבה ומסייעת בתכנון הפתרון המתאים בהתאם
              למבנה ולמיקום.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              הצבת המבנה במקום החדש
            </h2>

            <p>
              לאחר הגעת המבנה אל היעד, יש לבצע את שלב ההצבה
              בצורה מדויקת. במקרים שבהם המבנה צריך להיות ממוקם
              בנקודה מסוימת, נדרשת שליטה טובה בתהליך ההרמה
              וההנחה.
            </p>

            <p>
              תכנון נכון מראש מאפשר להגיע אל נקודת ההצבה בצורה
              יעילה ולהתאים את אמצעי ההרמה לתנאים הקיימים באתר.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              העברת מבנים במקומות עם גישה מורכבת
            </h2>

            <p>
              לא בכל מקום ניתן להגיע בקלות עם ציוד כבד. לעיתים
              מדובר בחצרות, רחובות צרים, אזורים צפופים או אתרים
              שבהם קיימות מגבלות גישה.
            </p>

            <p>
              במצבים כאלה חשוב לבצע בדיקה מקדימה של האתר ולתכנן
              את העבודה בהתאם למגבלות הקיימות. התאמת הציוד
              ותכנון שלבי העבודה יכולים לסייע בביצוע מסודר
              ויעיל יותר.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להעברת מבנים?
            </h2>

            <p>
              העברת מבנה היא פעולה מורכבת ולכן חשוב לעבוד עם
              חברה בעלת ניסיון בתחום ההובלה וההרמה. תכנון נכון
              מסייע לזהות מראש את האתגרים ולבחור את הפתרון
              המתאים לעבודה.
            </p>

            <p>
              נצר הובלות ומנופים מתאימה את פתרון ההרמה וההובלה
              לתנאי השטח, לסוג המבנה ולדרישות הפרויקט.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – העברת מבנים בפריסה ארצית
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי הובלה, הרמה
              ומנוף למגוון רחב של עבודות, כולל העברת מבנים,
              הרמת מבנים והובלת ציוד כבד.
            </p>

            <p>
              צריכים להעביר מבנה ממקום למקום? צרו איתנו קשר,
              ספרו לנו על העבודה ונבחן עבורכם את פתרון ההרמה
              וההובלה המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Transportation_of_protective_equipment_and_mobile_safe_room"
              className="link-right"
            >
              הובלת מיגונית וממ"ד נייד
            </Link>

            <Link
              to="/Lifting_Buildings"
              className="link-left"
            >
              הרמת מבנים
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}